import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './ProductTitle.scss';
import classNames from 'classnames';
export function ProductTitle({ title, subTitle, size = 'medium', dataHook, className, }) {
    return (React.createElement(Box, { dataHook: dataHook, className: className, direction: "vertical", textAlign: "center", align: "center", gap: "SP1" },
        React.createElement(Text, { className: classNames(s.title, {
                [s.minimized]: size === 'small',
            }), maxLines: 2, ellipsis: true }, title),
        subTitle ? (React.createElement(Text, { size: "small", maxLines: 3, ellipsis: true }, subTitle)) : null));
}
//# sourceMappingURL=ProductTitle.js.map